export const aciPicnicArea = {
    iconName: 'picnic-area',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M4.305 11.613a.684.684 0 00-.684.684 6.603 6.603 0 006.603 6.603h3.552a6.603 6.603 0 006.603-6.603.684.684 0 00-.684-.684H4.305zm-1.19-.506a1.684 1.684 0 011.19-.494h15.39a1.684 1.684 0 011.684 1.684 7.603 7.603 0 01-7.603 7.603h-3.552a7.603 7.603 0 01-7.603-7.603c0-.446.178-.875.493-1.19z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M2.719 13.48a.5.5 0 01.5-.5h17.56a.5.5 0 110 1H3.22a.5.5 0 01-.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M11.857 13.002a.5.5 0 01.622.335l1.776 5.92a.5.5 0 11-.958.287l-1.776-5.92a.5.5 0 01.335-.622z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M12.144 13.002a.5.5 0 01.335.622l-1.775 5.92a.5.5 0 01-.958-.288l1.776-5.92a.5.5 0 01.622-.334zM16.557 13.013a.5.5 0 01.645.29l1.616 4.25a.5.5 0 11-.934.355l-1.617-4.25a.5.5 0 01.29-.645z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M16.921 13.017a.5.5 0 01.278.65l-2.368 5.895a.5.5 0 01-.928-.373l2.368-5.895a.5.5 0 01.65-.277zM7.443 13.013a.5.5 0 01.29.645l-1.617 4.25a.5.5 0 11-.935-.356l1.617-4.25a.5.5 0 01.645-.289z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M7.077 13.017a.5.5 0 01.65.277l2.368 5.895a.5.5 0 01-.927.373L6.8 13.667a.5.5 0 01.277-.65zM11.128 4.211a.5.5 0 01.078.703l-4.735 5.92a.5.5 0 01-.781-.625l4.735-5.92a.5.5 0 01.703-.078zM12.871 4.211a.5.5 0 01.703.078l4.736 5.92a.5.5 0 01-.781.624l-4.736-5.92a.5.5 0 01.078-.702z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
